import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const posOrderCountWidget: DashboardWidgetConfiguration = {
  widgetId: "pos.order-count",
  name: "POS orders",
  description: "POS orders for the selected dashboard period.",
  apps: [
    "point-of-sale",
  ],
  template: "number",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "pos.orders",
      ...period(30),
      select: [
        {
          type: "aggregate",
          function: "count_distinct",
          field: "record_id",
          as: "value",
        },
      ],
    },
  },
  inputs: {
    label: "Orders",
    subtext: "in the last 30 days",
    icon: "orders",
    color: "primary",
    valueFormat: "number",
    valueMultiplier: 1,
  },
  dummyData: {
    value: 386,
    subtext: "Last 30 days",
  },
  limits: {
    minWidth: 2,
    maxWidth: 6,
    minHeight: 1,
    maxHeight: 2,
    defaultWidth: 4,
    defaultHeight: 1,
  },
};
